import React from 'react';
import { Box, Container, Divider, Heading, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Internal testing table of contents
 * This page is only accessible to Fora employees and lists all internal testing pages
 *
 * @returns {JSX.Element} Fora testing page
 */
export default function ForaTestingPage() {
  return (
    <Container
      maxW='container.lg'
      py={8}
    >
      <VStack
        spacing={8}
        align='stretch'
      >
        <Box>
          <Heading
            size='xl'
            mb={4}
          >
            Fora Internal Testing Pages
          </Heading>
          <Text
            fontSize='lg'
            color='surface.onSurfaceVariant'
          >
            This page provides access to all internal testing tools and pages used for development
            and debugging. These pages are only accessible to Fora employees.
          </Text>
        </Box>

        <Divider />

        <SimpleGrid
          columns={{ base: 1, md: 2 }}
          spacing={8}
        >
          <Box
            p={5}
            borderWidth='1px'
            borderRadius='lg'
            shadow='sm'
            transition='all 0.2s'
            _hover={{ shadow: 'md' }}
          >
            <Heading
              as='h2'
              size='md'
              mb={2}
              color='brand.primary'
            >
              <RouterLink to='/component-testing'>Component Testing</RouterLink>
            </Heading>
            <Text color='surface.onSurfaceVariant'>
              Test and preview UI components including color tokens, buttons, form fields, custom
              components, and other UI elements used throughout the application.
            </Text>
          </Box>

          <Box
            p={5}
            borderWidth='1px'
            borderRadius='lg'
            shadow='sm'
            transition='all 0.2s'
            _hover={{ shadow: 'md' }}
          >
            <Heading
              as='h2'
              size='md'
              mb={2}
              color='brand.primary'
            >
              <RouterLink to='/feature-gate-details'>Feature Gate Details</RouterLink>
            </Heading>
            <Text color='surface.onSurfaceVariant'>
              View and monitor all feature gates across the application, including their status,
              description, and configuration details. Useful for debugging feature flag related
              issues.
            </Text>
          </Box>

          <Box
            p={5}
            borderWidth='1px'
            borderRadius='lg'
            shadow='sm'
            transition='all 0.2s'
            _hover={{ shadow: 'md' }}
          >
            <Heading
              as='h2'
              size='md'
              mb={2}
              color='brand.primary'
            >
              <RouterLink to='/in-flux-features'>In-Flux Features</RouterLink>
            </Heading>
            <Text color='surface.onSurfaceVariant'>
              Test and preview features that are currently in development but not yet released,
              including Pulses and other experimental features.
            </Text>
          </Box>
        </SimpleGrid>
      </VStack>
    </Container>
  );
}
